import { useRef, useState } from 'react';
import Text from '../../../atoms/Text';
import Button from '../../../molecules/Button';
import { numberOnly } from './ParamField';
import {
  formatSettingsValue,
  validateSettingsValue,
} from '../helpers/settingsFormatters';

const MIN_GAS = 0.01;
const MAX_GAS = 10 ** 12;

interface IDepositWindowProps {
  onClose(): void;
  ntCurrency: string;
  onDeposit(input: number): void;
}

const DepositWindow = ({
  onClose,
  ntCurrency,
  onDeposit,
}: IDepositWindowProps) => {
  const depositRef = useRef<HTMLSpanElement>(null);
  const [gasAmount, setGasAmount] = useState(0.1);

  const handleKeyDown = (e: any) => numberOnly(e.nativeEvent);

  const onChange = (value: string | null) => {
    const formattedValue = formatSettingsValue(value || '');
    setGasAmount(formattedValue);
  };

  const handleSave = (value: string) => {
    const formattedValue = formatSettingsValue(value).toFixed(2);
    if (depositRef.current) {
      const isValid = validateSettingsValue(formattedValue, MIN_GAS, MAX_GAS);
      if (isValid) {
        setGasAmount(Number(formattedValue));
        depositRef.current.innerText = formattedValue;
      }
    }
  };

  return (
    <div className='gas__deposit_window'>
      <div
        className='price_alert__backdrop'
        onClick={(e) => {
          e.stopPropagation();
          onClose();
        }}
      />
      <div className='price_alert__create' onClick={(e) => e.stopPropagation()}>
        {/* to prevent from chart reacting to clicks */}
        <div className='row'>
          <Text size={14} className='text--grey-200 text--weight-600'>
            Deposit gas
          </Text>
          <div className='icon-close' onClick={() => onClose()} />
        </div>
        <div className='price_alert__create__new'>
          <div className='gas row priceSelector'>
            <div className='gas__deposit'>
              <div
                className={`gas__deposit__item ${
                  gasAmount === 0.1
                    ? 'gas__deposit__item--selected'
                    : 'gas__deposit__item--normal'
                }`}
                onClick={() => handleSave('0.1')}
              >
                <Text size={12}>0.1 {ntCurrency}</Text>
              </div>
              <div
                className={`gas__deposit__item ${
                  gasAmount === 0.5
                    ? 'gas__deposit__item--selected'
                    : 'gas__deposit__item--normal'
                }`}
                onClick={() => handleSave('0.5')}
              >
                <Text size={12}>0.5 {ntCurrency}</Text>
              </div>
              <div
                className={`gas__deposit__item ${
                  gasAmount === 1
                    ? 'gas__deposit__item--selected'
                    : 'gas__deposit__item--normal'
                }`}
                onClick={() => handleSave('1')}
              >
                <Text size={12}>1 {ntCurrency}</Text>
              </div>
            </div>
            <div className='gas params_panel__param input_wrapper'>
              <span
                className={`input_wrapper__editable ${
                  !validateSettingsValue(gasAmount, MIN_GAS, MAX_GAS)
                    ? 'input_wrapper--error'
                    : ''
                }`}
              >
                <span
                  suppressContentEditableWarning={true}
                  contentEditable={true}
                  onKeyDown={(e) => handleKeyDown(e)}
                  onBlur={(e) => handleSave(e.target.innerText)}
                  onInput={(e) => onChange(e.currentTarget.textContent)}
                  ref={depositRef}
                  className='text--14 text--weight-500 text--grey-200 '
                >
                  0.10
                </span>
              </span>
            </div>
          </div>

          <div className='row'>
            <div className='btnWrapper'>
              <Button
                text='Cancel'
                action={onClose}
                size='s'
                variant='secondary'
              />
            </div>
            <div className='btnWrapper'>
              <Button
                text='Deposit'
                disabled={!validateSettingsValue(gasAmount, MIN_GAS, MAX_GAS)}
                action={() => onDeposit(gasAmount)}
                size='s'
                variant='primary'
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DepositWindow;
